import {ActivatedRoute} from '@angular/router';
import {CommonService} from '../../services/common.service';
import {Component, Input, OnInit} from '@angular/core';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  selector: 'app-sale-point-agreement',
  templateUrl: './sale-point-agreement.component.html'
})
export class SalePointAgreementComponent implements OnInit {
  salePointId: number;
  agreements: any;
  @Input() customerName: any;

  constructor(private activatedRoute: ActivatedRoute,
              private commonService: CommonService,
              private toastMessagesService: ToastMessagesService) {
  }

  public async ngOnInit(): Promise<any> {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.salePointId = +params.get('id');
    });

    await this.initAgreements();
  }

  async initAgreements() {
    try {
      this.agreements = await this.commonService.getList(`agreement/sale_point_agreements/${this.salePointId}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async getAgreementReport(agreement) {
    try {
      await this.commonService.getPDF(`agreement/PDF/${agreement.id}`, `Συμφωνία ${this.customerName} - ${agreement.year}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }
}
